import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCloudComponent } from "./med-icon-cloud.component";

@NgModule({
  declarations: [
    MedIconCloudComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCloudComponent,
  ],
})
export class MedIconCloudModule { }
